import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import '../css/footer.css';

export default class Footer extends Component {
  render() {
    return(
      <div className="footer">
      <div className="container-fluid">
       <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div className="footerIcon">
            <Link to="https://www.facebook.com/HerbalCure/?ref=settings" target="_blank"></Link>
            <Link to="https://line.me/R/ti/p/%40amt1895f" target="_blank"></Link>
            <Link to="https://www.instagram.com/herbalcure2520/" target="_blank"></Link>
          </div>
          <div>
           <Link to="/About">關於我們</Link>
           <a href="/Contact">聯絡我們</a>
           <Link to="/Disclaimer">免責聲明</Link>
           <Link to="/Privacy-Policy">隱私權</Link>
          </div>
          <p>copyright &copy; 2017, 草學藥事(翻印必究)<span className="mobilenone"> ALL rights reserved.</span> <br /> 總代理:傑宇特科技有限公司</p>
        </div>
       </div>
      </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Layout/Footer.js